export const navigateToRoute = (href: string) => window.location.assign(href);

export const getAvailabilitiesUrl = (locationSlug: string) =>
  `/locations/${locationSlug}`;

export const getBookingConfirmationUrl = (
  locationSlug: string,
  bookingId: string
) => `/locations/${locationSlug}/booking/${bookingId}`;

export const getModifyBookingUrl = (
  locationSlug: string,
  bookingId: string,
  visitId: string | null
) =>
  `/locations/${locationSlug}/booking/${bookingId}/modify${visitId ? `?visitId=${visitId}` : ''}`;

export const getMenuPageUrl = (locationSlug: string) =>
  `/locations/${locationSlug}/menu`;
